import { formatDateShort } from "shared/src/utils/date-utils";

export const formatDateForDisplay = (date: Date | string | null): string => {
  if (!date) return "";

  try {
    return formatDateShort(date);
  } catch {
    return "";
  }
};
